import {IStore} from '../store';
import {IPermissionsStore} from './permissions.interface';

export const permissionsSelector: (state: IStore) => IPermissionsStore =
  (state: IStore) => state.permissions;
